// A phone or tablet: a touch screen with no mouse. A touchscreen laptop (primary pointer is
// fine) is NOT a touch device here, so it keeps the desktop viewers.
export const TOUCH_DEVICE_QUERY = '(hover: none) and (pointer: coarse)';

export const isTouchDevice = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  try {
    return Boolean(window.matchMedia(TOUCH_DEVICE_QUERY).matches);
  } catch {
    return false;
  }
};
